/**
 * allDataJsonから取得したリンクデータの集合から、指定したリンクデータを抽出する関数
 * @param targetArray: 抽出したいリンクデータを含む配列
 * @param contentsArray: 抽出するデータのkeyの配列. この配列の順序でリンクデータが抽出される
 * @returns Array
 */

export default function extractLinkData(targetArray:Array<any>, contentsArray:Array<any>):Array<any>{

  // 条件に該当する配列を返す
  return contentsArray.map(content => {
      return targetArray.find(item=>{
        return item.key === content
      })
  })

}